import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            I am an Ingénieur DevOps with 9+ years of experience leading
            development teams and delivering business process automation and
            cloud platforms for companies like BNP Paribas Partners for
            Innovation, Canon Business Services and Profidéo.
            <br />
            I'm versatile across the back end with Java, Node.js and Python,
            and comfortable with front-end technologies like Angular and
            React. I have solid hands-on experience with Docker, Kubernetes,
            Helm, and Terraform.
            <p />
            <p>
              One of my favorite exercises is modeling and implementing BPM
              solutions. I use <span className="purple">Camunda BPM</span> for
              this task, backed by AWS serverless and cloud infrastructure.
            </p>
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing football
            </li>
            <li className="about-activity">
              <ImPointRight /> Coaching
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Innovate and improve the living conditions of users"{" "}
          </p>
          <footer className="blockquote-footer"></footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
